<div class="user" [class.super-duper-admin]="isSuperDuperAdmin" [class.god-mode-active]="godModeEnabled" *ngIf="user">
  <button
    class="sign-in-button"
    [class.has-avatar]="avatarUrl"
    [title]="godModeEnabled ? 'User menu — God mode active' : 'User menu'"
    aria-label="Open user menu"
    cdkOverlayOrigin
    #origin="cdkOverlayOrigin"
    (click)="isOpen = !isOpen"
    cdkMonitorElementFocus
  >
    <img *ngIf="avatarUrl" [src]="avatarUrl" class="user-avatar" alt="User avatar" />
    <ng-container *ngIf="!avatarUrl">
      <span class="user-button-content" *ngIf="usersFirstLetter; else userIcon">
        {{ usersFirstLetter.toUpperCase() }}
      </span>
      <ng-template #userIcon>
        <mat-icon class="user-button-content">person</mat-icon>
      </ng-template>
    </ng-container>
    <mat-icon class="user-button-content-mobile">{{ isOpen ? 'clear' : 'more_vert' }}</mat-icon>
  </button>
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayOpen]="isOpen"
    cdkConnectedOverlayHasBackdrop="true"
    cdkConnectedOverlayBackdropClass="aker-user-menu-backdrop"
    (backdropClick)="isOpen = false"
    (detach)="isOpen = false"
  >
    <div>
      <div
        class="user-menu-panel"
        [class.super-duper-admin]="isSuperDuperAdmin"
        [style.background]="isSuperDuperAdmin ? 'linear-gradient(160deg, #fce4ec, #f8bbd0 40%, #fce4ec 70%, #fff0f7)' : null"
        [style.border]="isSuperDuperAdmin ? '2px solid #f48fb1' : null"
        cdkTrapFocus cdkTrapFocusAutoCapture
      >
        <div class="flower-border-top" *ngIf="isSuperDuperAdmin">
          🌸 ✿ 🌺 ❀ 🌷 ✿ 🌸 ❀ 🌺 ✿ 🌷
        </div>
        <div class="profile-menu" (click)="clickOnUserInfo($event)" tabindex="0">
          <div class="user-overlay" *ngIf="user">
            <img *ngIf="avatarUrl" [src]="avatarUrl" class="user-overlay-avatar" alt="User avatar" />
            <ng-container *ngIf="!avatarUrl">
              <span class="user-button-content" *ngIf="usersFirstLetter; else userIcon">
                {{ usersFirstLetter.toUpperCase() }}
              </span>
              <ng-template #userIcon>
                <mat-icon class="user-button-content">person</mat-icon>
              </ng-template>
            </ng-container>
          </div>
          <p *ngIf="user.name" class="name">{{ user.name }}</p>
          <p *ngIf="user.email" class="email">{{ user.email }}</p>
          <div class="flower-divider" *ngIf="isSuperDuperAdmin">
            ❀ 🌸 ✿ 🌺 ✿ 🌸 ❀
          </div>
          <div class="role-cards" *ngIf="roleCards.length">
            <div
              class="role-card"
              [class.super-duper-admin]="isSuperDuperAdmin && card.icon === 'shield'"
              *ngFor="let card of roleCards"
            >
              <mat-icon class="role-card-icon">{{ card.icon }}</mat-icon>
              <span class="role-card-label">{{ card.label }}</span>
              <mat-icon class="role-card-help" [matTooltip]="card.description" matTooltipPosition="below">help_outline</mat-icon>
            </div>
          </div>
        </div>
        <div class="flower-divider" *ngIf="isSuperDuperAdmin">
          🌷 ✿ 🌸 ❀ 🌺 ❀ 🌸 ✿ 🌷
        </div>
        <div class="scroll-container">
          <div class="header-menu-items">
            <ng-content></ng-content>
          </div>
          <a
            href="https://ix3services.atlassian.net/servicedesk/customer/portal/21"
            class="support-link"
            target="_blank"
            cdkMonitorElementFocus
          >
            <svg width="22" height="22" xmlns="http://www.w3.org/2000/svg">
              <g fill="none" fill-rule="evenodd">
                <path d="M-1-1h24v24H-1z" />
                <path d="M11 0a3 3 0 110 6 3 3 0 010-6zm0 1.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z" fill="#FFF" fill-rule="nonzero" />
                <path fill="#FFF" d="M5 16h12v1H5zM0 12h22v2H0z" />
                <path
                  d="M11 7a6.002 6.002 0 015.659 4h-1.627a4.5 4.5 0 00-8.064 0H5.34C6.165 8.67 8.387 7 11 7zM20 12v10H2V12h18zm-1 1H3v8h16v-8z"
                  fill="#FFF"
                  fill-rule="nonzero"
                />
              </g>
            </svg>
            <span>Service desk</span>
            <mat-icon>open_in_new</mat-icon>
          </a>
        </div>
        <button aria-label="Sign out" class="sign-out-button" (click)="openUserPreference()" cdkMonitorElementFocus>
          <mat-icon>settings</mat-icon>
          <span>Preference</span>
        </button>
        @if (isAdminOrEditor) {
          <button aria-label="roadmap" class="sign-out-button" (click)="openRoadmap()" cdkMonitorElementFocus>
            <mat-icon>timeline</mat-icon>
            <span>Roadmap</span>
          </button>
        }
        <button aria-label="Toggle user manual" class="sign-out-button" (click)="toggleUserManual()" cdkMonitorElementFocus>
          <mat-icon>help_outline</mat-icon>
          <span>User manual</span>
          <span *ngIf="manualActive" class="manual-active-indicator">•</span>
        </button>
        <button aria-label="About" class="sign-out-button" (click)="openAbout()" cdkMonitorElementFocus>
          <mat-icon>info_outline</mat-icon>
          <span>About</span>
        </button>
        <a
          class="sign-out-button support-link"
          href="https://servicenow.akersolutions.com/esc?id=sc_cat_item&sys_id=98a848aa87e76110664862040cbb35a5"
          target="_blank"
          cdkMonitorElementFocus
        >
          <mat-icon>bug_report</mat-icon>
          <span>Report incident</span>
          <mat-icon class="external-icon">open_in_new</mat-icon>
        </a>
        <a
          class="sign-out-button support-link"
          href="https://servicenow.akersolutions.com/esc?id=sc_cat_item&table=sc_cat_item&sys_id=2a2998c797d76910c511f0b0f053af8a"
          target="_blank"
          cdkMonitorElementFocus
        >
          <mat-icon>library_add</mat-icon>
          <span>Request new feature</span>
          <mat-icon class="external-icon">open_in_new</mat-icon>
        </a>
        @if (godModeEligible || godModeEnabled) {
          <div class="god-mode-action-row">
            <button
              aria-label="Toggle god mode"
              class="sign-out-button god-mode-menu-button"
              [class.god-mode-menu-button--active]="godModeEnabled"
              [disabled]="godModeBusy"
              (click)="toggleGodMode()"
              cdkMonitorElementFocus
            >
              <mat-icon>{{ godModeEnabled ? 'gpp_bad' : 'admin_panel_settings' }}</mat-icon>
              <span>{{ godModeEnabled ? 'Disable God Mode' : 'Enable God Mode' }}</span>
            </button>
            <button
              type="button"
              class="god-mode-help-button"
              aria-label="Open God Mode user manual"
              title="God Mode user manual"
              (click)="openGodModeManual()"
            >
              ?
            </button>
          </div>
        }
        <button aria-label="Sign out" class="sign-out-button" (click)="signOut()" cdkMonitorElementFocus>
          <mat-icon>exit_to_app</mat-icon>
          <span>Log out</span>
        </button>
        <div class="flower-border-bottom" *ngIf="isSuperDuperAdmin">
          🌸 ✿ 🌺 ❀ 🌷 ✿ 🌸 ❀ 🌺 ✿ 🌷
        </div>
      </div>
    </div>
  </ng-template>
</div>

<p-dialog
  header="God Mode Access Approval"
  [(visible)]="godModePendingApprovalDialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: 'min(520px, 94vw)' }"
  styleClass="god-mode-information-dialog"
>
  <div class="god-mode-information-content">
    <div class="god-mode-information-icon"><mat-icon>pending_actions</mat-icon></div>
    <div>
      <h3>Your access request is awaiting approval</h3>
      <p>Your request has been registered using your Entra account.</p>
      <p>An administrator must approve it before you can enable God Mode. Please try again after approval has been granted.</p>
    </div>
  </div>
  <div class="god-mode-dialog-actions">
    <button type="button" pButton label="Close" (click)="godModePendingApprovalDialogVisible = false"></button>
  </div>
</p-dialog>

<p-dialog
  header="God Mode User Manual"
  [(visible)]="godModeManualDialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: 'min(780px, 96vw)' }"
  styleClass="god-mode-manual-dialog"
>
  <div class="god-mode-manual-content">
    <p><strong>God Mode</strong> is a controlled, time-limited mode for authorised administrators to perform exceptional checksheet corrections and related MIPS actions.</p>

    <h3>Who can use it?</h3>
    <ul>
      <li>You must have the Azure AD <strong>ADMIN</strong> role.</li>
      <li>You must have administrator access to the current project.</li>
      <li>Your Entra account must be approved for God Mode.</li>
    </ul>

    <h3>Requesting access</h3>
    <p>Select <strong>Enable God Mode</strong>. If this is your first request, it is registered automatically and remains disabled until an administrator approves it. You will receive a confirmation dialog while approval is pending.</p>

    <h3>Using God Mode safely</h3>
    <ul>
      <li>Use normal Completion workflows whenever possible. Use God Mode only for approved exceptional work.</li>
      <li>God Mode automatically turns off after <strong>one minute without mouse activity</strong>. A warning is shown during the final 10 seconds.</li>
      <li>Disable God Mode when you have finished. Signing out also disables it.</li>
      <li>God Mode changes and related MIPS operations are recorded for audit purposes.</li>
    </ul>

    <p class="god-mode-manual-note"><strong>Tip:</strong> If access remains pending, contact an administrator responsible for God Mode approvals.</p>
  </div>
  <div class="god-mode-dialog-actions">
    <button type="button" pButton label="Close" (click)="godModeManualDialogVisible = false"></button>
  </div>
</p-dialog>

